import { Dispatch, SetStateAction } from "react";

import useInvoiceFilters from "hooks/filters/useInvoiceFilters";
import FilterAccordions from "components/organisms/Filter/components/FilterAccordions";

interface EditFilterProps {
  currentFilters: Record<string, any> | undefined;
  setFilters: Dispatch<SetStateAction<Record<string, any> | undefined>> | Function;
}

function EditInvoiceFilter({ currentFilters, setFilters }: EditFilterProps) {
  const { config } = useInvoiceFilters();

  const eventContext = "Edit Invoice Preset";

  if (!currentFilters) return null;
  return (
    <FilterAccordions config={config} currentFilters={currentFilters} setFilters={setFilters} eventContext={eventContext} />
  );
}

export default EditInvoiceFilter;
